import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'
import { getCoinIcon } from '@/lib/common'
import type { TokenInfo } from '@/types'

interface TokenRowProps {
  token: TokenInfo | null
  amount: string
  balance: string | null
  onTokenClick: () => void
  onInput: (value: string) => void
  onBalanceClick?: () => void
  readOnly?: boolean
}

export function TokenRow({
  token,
  amount,
  balance,
  onTokenClick,
  onInput,
  onBalanceClick,
  readOnly = false,
}: TokenRowProps) {
  const { t } = useTranslation()

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    if (val === '' || /^\d*\.?\d*$/.test(val)) {
      onInput(val)
    }
  }

  return (
    <div>
      {/* Row 1: Token selector + Balance */}
      <div className="flex items-center justify-between mb-[18px]">
        {/* Token selector */}
        <button onClick={onTokenClick} className="flex items-center gap-[11px] cursor-pointer">
          {token ? (
            <img
              src={getCoinIcon(token.contract, token.coin)}
              alt={token.coin}
              className="w-[29px] h-[29px] rounded-full bg-gray-100"
              onError={(e) => { (e.target as HTMLImageElement).src = '' }}
            />
          ) : (
            <div className="w-[29px] h-[29px] rounded-full bg-gray-200" />
          )}
          <span className="text-[16px] font-semibold text-[#091b3d]">
            {token?.coin || t('swap.selectToken')}
          </span>
          <ChevronDown className="h-4 w-4 text-[#333]" />
        </button>

        {/* Balance */}
        {balance !== null && token && (
          <span
            className="text-[14px] text-[#091b3d] cursor-pointer"
            onClick={onBalanceClick}
          >
            Balance: {balance} {token.coin}
          </span>
        )}
      </div>

      {/* Row 2: Input box */}
      <div className="h-[59px] rounded-[16px] border-2 border-[#d1e2ce]">
        <input
          type="text"
          inputMode="decimal"
          value={amount}
          onChange={handleInput}
          readOnly={readOnly}
          placeholder="0.0"
          className="w-full h-full px-[20px] bg-transparent text-[16px] font-bold text-[#498846] text-right outline-none placeholder:text-[#498846]"
        />
      </div>
    </div>
  )
}
